import React, { useCallback } from 'react';

import List from '@mui/material/List';

import { Attachment, AttachmentCategory, Case, CaseVideoRequest } from '../../api/caseApiTypes';
import { Right } from '../../api/userApi';
import { useAppDispatch } from '../../hooks/useAppRedux';
import { useEitherRights } from '../../hooks/useRights';
import { AddAttachmentListItem } from '../attachment/AddAttachmentListItem';
import { AttachmentListItem } from '../attachment/AttachmentListItem';
import { removeCaseVideoRequestAttachment, uploadVideoRequestAttachment } from './caseDetailSlice';
import { UploadProgressHandlerForFile } from '../../api/commonApiTypes';

interface Props {
  className?: string;
  caze: Case;
  videoRequest: CaseVideoRequest;
  onDelete?: (attachment: Attachment) => void;
  category: AttachmentCategory;
  right: Right;
  isNewCase?: boolean;
}

export const CaseVideoRequestAttachments: React.FC<Props> = ({ className, caze, videoRequest, onDelete, category, right, isNewCase }) => {
  const canManageAttachments = useEitherRights([Right.Administration, right]);
  const dispatch = useAppDispatch();

  const onDrop = useCallback(
    (files: File[], onUploadProgress: UploadProgressHandlerForFile) => {
      dispatch(uploadVideoRequestAttachment({ caze, videoRequest, category, files, onUploadProgress }));
    },
    [dispatch, caze, category],
  );

  const removeVideoRequestAttachment = (item: Case, videoRequest: CaseVideoRequest, attachment: Attachment) => {
    dispatch(removeCaseVideoRequestAttachment({item, videoRequest, attachment}));
  }

  const attachments = (videoRequest?.attachments ?? []).filter(attachment => attachment.category === category);

  return (
    <div className={className}>
      {isNewCase && <p>Du kan lägga till bilagor efter beställningen är sparad</p>}
      {!isNewCase && (
        <List>
          {canManageAttachments && <AddAttachmentListItem onDrop={onDrop} category={category} />}
          {attachments
            .map((attachment, index) => (
              <AttachmentListItem key={index} attachment={attachment} onDelete={() => removeVideoRequestAttachment(caze, videoRequest, attachment)} readonly={!canManageAttachments} />
            ))
            .reverse()}
        </List>
      )}
    </div>
  );
};
